<div class="range-filter-section">
  <label>{{ label }}</label>
  <div class="range-filter">
    <div class="rangeValue">{{ this.minValue.value }}</div>
    <mat-slider class="range-slider" [min]="min" [max]="max">
      <input matSliderStartThumb class="thumb" [value]="minValue.value" (valueChange)="minValue.setValue($event); onSliderChange()" />
      <input matSliderEndThumb class="thumb" [value]="maxValue.value" (valueChange)="maxValue.setValue($event); onSliderChange()" />

      <div class="slider-labels">
        <div class="minlimit">{{ min }}</div>
        <div class="maxlimit">{{ max }}</div>
      </div>
    </mat-slider>

    <div class="rangeValue">{{ this.maxValue.value }}</div>
  </div>
</div>
